{
  "version": 1,
  "asset_id": "ada8d565-ff77-427f-b60b-71852fade233",
  "project_id": "7580f3ab-e7a4-418d-abe6-5eb616986e51",
  "url": "/__l5e/assets-v1/ada8d565-ff77-427f-b60b-71852fade233/homosassa-blue-metal-roof-installation-480w.webp",
  "r2_key": "a/v1/7580f3ab-e7a4-418d-abe6-5eb616986e51/ada8d565-ff77-427f-b60b-71852fade233/homosassa-blue-metal-roof-installation-480w.webp",
  "original_filename": "homosassa-blue-metal-roof-installation-480w.webp",
  "size": 24140,
  "content_type": "image/webp",
  "created_at": "2026-07-21T19:37:52Z"
}
